<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

	const router = useRouter()
	const tickLabels = {
			0: 'Not interested',
			1: 'Let me think',
			2: 'Sign me up!',
			}
	const stepId: any = ref(0)

	function goToRegistrationPage() {
		if (stepId.value === 2) {
			router.push({ path: "/registration/worker" })
		}
	}

</script>

<template>
    <div class="email-newsletter bg-lightinfo py-md-12 py-5 position-relative">
			<div class="py-md-8 py-sm-5">
				<v-container>
					<v-row class="justify-center text-center">
						<v-col cols="12" md="8">
							<div data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
								<h2 class="text-center text-h2 text-dark font-weight-bold mb-5">Are you the best?</h2>
								<p class="text-muted  text-body-1 mb-7">Join Treelet as a Professional, contribute, get compensated and rise to the stars.</p>
								<v-row class="justify-center pt-7">
									<v-col cols="12" sm="9">
										<v-slider
										v-model="stepId"
										:max="2"
										:ticks="tickLabels"
										:thumb-size="40"
										color="primary"
										show-ticks="always"
										step="1"
										tick-size="3"
										@click="goToRegistrationPage"
										></v-slider>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
    </div>
</template>
<style>
.v-slider.v-input--horizontal .v-slider-track__tick .v-slider-track__tick-label {
	margin-top: calc(var(--v-slider-track-size) / 2 + 22px);
}
</style>